import {
  EViewerMode,
  ProjectDetailContext,
} from "../Interfaces/ProjectDetailInterfaces";
import { Q3DTabPanel } from "../../Parts/Q3DTabPanel";
import { useContext, useEffect, useState } from "react";
import { Box, useTheme } from "@mui/material";
import { Vector3 } from "three";
import React from "react";

type Props = {
  width?: string;
};

export const DefaultTabPanel = (props: Props) => {
  const [cursorCoord, setCursorCoord] = useState<string>(null);
  const { viewer, currentViewerMode } = useContext(ProjectDetailContext);

  const theme = useTheme();

  const startCoordTracking = () => {
    viewer.startCoordTracking((res: Vector3) => {
      if (res) {
        setCursorCoord(
          `X: ${res.y.toFixed(3)} Y: ${res.x.toFixed(3)} Z: ${res.z.toFixed(3)}`
        );
      } else {
        setCursorCoord(null);
      }
    });
  };

  // The coordinate read-out only makes sense in the default view. Every pick
  // re-renders the whole scene twice + does a synchronous GPU readback (see
  // PointCloudBVH), so leaving it live in other modes — IFC placement / editor
  // especially — stutters those interactions for a label nobody is reading.
  // Tear it down outside DEFAULT and (re)start it when we come back.
  useEffect(() => {
    if (currentViewerMode !== EViewerMode.DEFAULT) {
      viewer.endCoordTracking();
      setCursorCoord(null);
      return;
    }
    const onPointLoaded = () => startCoordTracking();
    document.addEventListener("pointloaded", onPointLoaded);
    startCoordTracking(); // handler already loaded — start immediately too

    return () => {
      document.removeEventListener("pointloaded", onPointLoaded);
      viewer.endCoordTracking();
    };
  }, [currentViewerMode]);

  return (
    <Q3DTabPanel
      value={EViewerMode.DEFAULT}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "var(--space-space--4, 4px)",
        width: props.width,
        paddingLeft: "4px",
      }}
    >
      <Box sx={{ color: theme.palette.base.contrast }}>
        {cursorCoord ? cursorCoord : `X: --.---  Y: --.---   Z: --.---`}
      </Box>
    </Q3DTabPanel>
  );
};
